export class OcLogRequest{
    user: string;
    s_ins: number;
    lines: number;
    date_begin: string;
    date_end: string;
    time_begin: string;
    time_end: string;
    tm: number;
    seq: number;
    filter_tp: number;

    constructor(user: string, s_ins: number, lines = 250, date_begin?: string, date_end?: string, filter_tp = 0, tm?: number, seq?: number,
         time_begin?: string, time_end?: string){
            this.user = user;
            this.s_ins = s_ins;
            this.lines = lines;
            this.date_begin = date_begin;
            this.date_end = date_end;
            this.time_begin = time_begin;
            this.time_end = time_end;
            this.tm = tm;
            this.seq = seq;
            this.filter_tp = filter_tp;
    }
}